<template>
  <f7-page no-toolbar no-swipeback login-screen @page:init="onPageInit" class="page-login" >
    <f7-navbar>
      <f7-nav-left>
        <f7-link @click="back">
          <i class="f7-icons">chevron_left</i>
        </f7-link>
      </f7-nav-left>
      <f7-nav-title style="">{{ $t("login_0001") }}</f7-nav-title>
      <f7-nav-right class="nav-balance">
        <f7-link external :target="isAppDevice?'_self':'_blank'" v-if="baseInfo.MobileService && baseInfo.MobileService != ''" :href="baseInfo.MobileService">
          <!-- <img class="btn-dowload" src="../../static/images/yt999/ting.png" height="22" /> -->
          <i class="bi bi-headset" style="font-size: 20px;"></i>
        </f7-link>
        <f7-link @click="openChangeLanguagePopup">
          <i class="bi bi-globe" style="font-size: 20px;"></i>
          <!-- <img class="btn-dowload" src="../../static/images/yt999/lang.png" height="24" style="margin-right: 10px" /> -->
        </f7-link>
      </f7-nav-right>
    </f7-navbar>
    <f7-login-screen-title>
      <img src="../../static/images/yt999/merchant/default/logo/dlog.png" />
    </f7-login-screen-title>
    <form autocomplete="off" class="list no-hairlines-md">
      <ul style="margin: 0 13px;">
        <li class="item-content item-input item-input-with-info">
          <div class="item-media">
            <i class="f7-icons bi-file-person" ></i>
          </div>
          <div class="item-inner">
            <div class="item-input-wrap">
              <input type="text" :placeholder="$t('login_0002')" v-model="username" :data-error-message="$t('login_0003')" />
              <span class="input-clear-button"></span>
            </div>
          </div>
        </li>
        <li class="item-content item-input item-input-with-info">
          <div class="item-media">
            <i class="f7-icons bi-lock"></i>
          </div>
          <div class="item-inner">
            <div class="item-input-wrap">
              <input id="login-pwd" autocomplete="off" :type="!togglePwdType ? 'password' : 'text'" v-model="password" :placeholder="$t('login_0004')" :data-error-message="$t('login_0005')" />
              <i class="f7-icons input-eyes" @click.self="togglePassword" v-if="togglePwdType">eye</i>
              <i class="f7-icons input-eyes" @click.self="togglePassword" v-else>eye_slash</i>
            </div>
          </div>
        </li>
        <li class="item-content item-input item-input-with-info" v-if="baseInfo.CheckVerifyCodeOnMemberLogin">
          <div class="item-media">
            <i class="f7-icons bi-shield-lock"></i>
          </div>
          <div class="item-inner">
            <div class="item-input-wrap">
              <input type="text" name="user-verify" v-model="verifyCode" :placeholder="$t('login_0006')" required />
              <span class="span-verify">
                <img @click.self="updateVerify" :src="`${verifyUrl}`" alt />
              </span>
            </div>
          </div>
        </li>
      </ul>
      <f7-block class="panel-forgetpwd">
        <f7-row no-gap>
          <f7-col>
            <!-- <f7-link @click="forgetPwd" class="span-forgetpwd color-lightblue text-14">{{ baseInfo.MobileService?$t("login_0007"):"" }}</f7-link> -->
          </f7-col>
          <f7-col class="text-right">
            <span class="color-graytint text-14">{{ $t("login_0008") }}</span>
            <f7-toggle color="blue" @change="rememberPwd" :checked="toggleChecked"></f7-toggle>
          </f7-col>
        </f7-row>
      </f7-block>
      <f7-block strong>
        <f7-button fill raised large @click="signIn" class="login-button">{{ $t("login_0009") }}</f7-button>
        <f7-block-footer>
          {{ $t("login_0010") }}
          <f7-link href="/register/" class="color-lightblue">{{ $t("login_0011") }}</f7-link>
        </f7-block-footer>
      </f7-block>
    </form>

    <!-- 在线客服popup -->
    <f7-popup v-show="showOnlinePopup" class="onlineCustom-popup" :opened="onlinePopupOpened" @popup:open="openOnlinePopup" @popup:close="closeOnlinePopup">
      <f7-page>
        <f7-navbar :title="$t('login_0012')">
          <f7-nav-right>
            <f7-link popup-close><i class="f7-icons">multiply_circle</i></f7-link>
          </f7-nav-right>
        </f7-navbar>
        <iframe :src="onlineCustomUrl" class="iframe-onlineCustom" frameborder="0"></iframe>
      </f7-page>
    </f7-popup>
  </f7-page>
</template>

<script>
import api from "../../config/api";
import { getStore, removeStore, setStore, setCookie, getCookie } from "../../config/utils";
import { getInfo, login, checkUserLogin, pow } from "../../axios/api";
import { mapGetters, mapMutations } from "vuex";
import common from "../../service/common";
import { sha256 } from "../../service/sha256";

export default {
  data() {
    return {
      username: "",
      password: "",
      verifyCode: "",
      verifyUrl: "",
      isAppDevice: getStore("device"),
      toggleChecked: false,
      togglePwdType: false,
      checkInterval: null,
      onlinePopupOpened: false,
      onlineCustomUrl: "",
      getInfoStatus: true,
      showVerifyCode: true,
      baseInfo: {},
      showOnlinePopup: true,

      loginLoading: null,
      rePow: { Challenge: "", Timestamp: "" },
      myPow: { Nonce: "", Hash: "" },
      isSigningIn: false,
      powWorker: null,
      toastLoginStatus: null,
    };
  },
  computed: {
    ...mapGetters(["getMerchantInfo", "getLoginState", "onlineCustomLoaded"]),
  },
  watch: {
    getMerchantInfo: function (val) {
      this.baseInfo = val.BaseInfo;
    },
  },
  methods: {
    ...mapMutations(["SETLOGINSTATE", "SETLOGININFO"]),
    onPageInit() {},
    createPowWorker() {
      return new Worker(new URL("../../workers/member-login-pow.worker.js", import.meta.url));
    },
    back() {
      this.$f7router.navigate("/");
    },

    async pow() {
      try {
        const data = await pow();
        if (data.Code !== "NoError" || !data.Data) {
          this.handlePowFailure((data && data.Data) || this.$t("login_0018"));
          return false;
        }

        this.rePow = data.Data;
        const powResult = await this.calculateMemberLoginPowWithWorker(data.Data, 20000);
        if (!powResult) {
          this.handlePowTimeout();
          return false;
        }

        this.myPow = powResult;
        return true;
      } catch (error) {
        this.handlePowFailure(this.$t("login_0018"));
        return false;
      }
    },
    cleanupPowWorker() {
      if (this.powWorker) {
        this.powWorker.terminate();
        this.powWorker = null;
      }
    },
    closeLoginLoading() {
      if (this.loginLoading) {
        this.loginLoading.close();
        this.loginLoading = null;
      }
    },
    async calculateMemberLoginPowWithWorker(powSetting, maxCalculateMs = 20000) {
      try {
        return await this.calculateMemberLoginPowByWorker(powSetting, maxCalculateMs);
      } catch (error) {
        return this.calculateMemberLoginPow(powSetting, maxCalculateMs);
      }
    },
    calculateMemberLoginPowByWorker(powSetting, maxCalculateMs = 20000) {
      this.cleanupPowWorker();

      return new Promise((resolve, reject) => {
        let worker = null;
        const clearWorker = () => {
          if (worker) {
            worker.terminate();
          }
          if (this.powWorker === worker) {
            this.powWorker = null;
          }
          worker = null;
        };

        try {
          worker = this.createPowWorker();
          this.powWorker = worker;

          worker.onmessage = (event) => {
            const message = event.data || {};
            clearWorker();
            if (message.success && message.data) {
              resolve(message.data);
              return;
            }
            resolve(null);
          };

          worker.onerror = (error) => {
            clearWorker();
            reject(error);
          };

          worker.postMessage({
            ...powSetting,
            maxCalculateMs,
          });
        } catch (error) {
          clearWorker();
          reject(error);
        }
      });
    },
    calculateMemberLoginPow(powSetting, maxCalculateMs = 20000) {
      const challenge = powSetting.Challenge;
      const timestamp = powSetting.Timestamp;
      const binding = powSetting.Binding;
      const difficulty = powSetting.Difficulty;
      const targetPrefix = "0".repeat(difficulty);
      const startedAt = Date.now();
      const expireMs = powSetting.ExpireSeconds * 1000;
      const calculateTimeoutMs = Math.min(expireMs, maxCalculateMs);

      for (let nonce = 0; ; nonce++) {
        if (Date.now() - startedAt >= calculateTimeoutMs) {
          return null;
        }

        const nonceText = nonce.toString();
        const source = `${challenge}|${nonceText}|${timestamp}|${binding}`;
        const hash = sha256(source);
        if (hash.startsWith(targetPrefix)) {
          return {
            Challenge: challenge,
            Nonce: nonceText,
            Hash: hash,
            Timestamp: timestamp,
          };
        }
      }
    },
    handlePowFailure(message) {
      this.closeLoginLoading();
      this.cleanupPowWorker();
      this.isSigningIn = false;
      this.$f7.params.dialog.closeByBackdropClick = true;
      this.$f7.$(".dialog-backdrop").css("background-color", "rgba(0, 0, 0, 0.74)");
      this.$f7.dialog.alert(message || this.$t("login_0018"), this.$t("common_0004"));
    },
    handlePowTimeout() {
      this.handlePowFailure(this.$t("login_0018"));
    },
    openChangeLanguagePopup() {
      const self = this;
      self.$f7.params.dialog.closeByBackdropClick = true; //点击背景关闭
      self.$f7.dialog.open("#dialog-change-language", true);
    },
    signIn() {
      const self = this;
      const app = self.$f7;
      if (self.isSigningIn) {
        return;
      }
      if (self.baseInfo.CheckVerifyCodeOnMemberLogin && !self.verifyCode) {
        app.dialog.alert(this.$t("login_0013"), this.$t("common_0004"));
        return;
      }
      if (!self.username) {
        app.dialog.alert(this.$t("login_0014"), this.$t("common_0004"));
        return;
      }
      if (!self.password) {
        app.dialog.alert(this.$t("login_0015"), this.$t("common_0004"));
        return;
      }
      self.$f7.params.dialog.closeByBackdropClick = false;
      //self.$f7.$('.dialog-backdrop').css('background-color', 'transparent'); 
      self.closeLoginLoading();
      self.loginLoading = self.$f7.dialog
        .create({
          title: "",
          text: this.$t("login_0016"),
          cssClass: "dialog-preloadgame",
        })
        .open();
      self.isSigningIn = true;

      if (self.baseInfo.EnablePowCheckOnMemberLogin) {
        this.pow().then((ready) => {
          if (!ready) {
            return;
          }
          this.login(true);
        });
      } else {
        setTimeout(() => {
          this.login(false);
        }, 3000);
      }
    },
    async login(enablePow = this.baseInfo.EnablePowCheckOnMemberLogin) {
      const self = this;
      const params = {
        UserName: self.username,
        Password: self.password,
        VerifyCode: self.verifyCode,
        Device: getStore("device") ? getStore("device") : "Mobile",
        AppVer: getStore("appVer") ? getStore("appVer") : "",
        ClientID: getStore("cid") ? getStore("cid") : "",
      };

      if (enablePow) {
        params.Pow = {
          Challenge: this.rePow.Challenge,
          Nonce: this.myPow.Nonce,
          Hash: this.myPow.Hash,
          Timestamp: this.rePow.Timestamp,
        };
      }

      let d = { data: JSON.stringify(params) };
      try {
        const data = await login(d);
        if (data.Code === "NoError" && data.Data) {
          removeStore("userInfo");
          self.SETLOGINSTATE(true); //设置登录状态为true
          self.SETLOGININFO(data.Data); //存储Vuex store userinfo
          setCookie("zz", data.Data.SessionId, 7);
          setStore("zz", data.Data.SessionId);
          setCookie("LoginName", data.Data.LoginName, 7);
          setCookie("blance", data.Data.Balance, 7);
          setCookie("test", data.Data.IsTest, 7);
          setCookie("p", data.Data.PromoCode, 7);
          setCookie("EnableSendRedPacket", data.Data.EnableSendRedPacket, 7);
          self.setUserStore(self.username, self.password, data.Data); //存储localStore userinfo
          //self.loginCheck();

          if (self.toastLoginStatus) {
            self.toastLoginStatus.destroy();
            self.toastLoginStatus = null;
          }

          self.toastLoginStatus = self.$f7.toast
            .create({
              text: this.$t("login_0017"),
              position: "center",
              closeTimeout: 1000,
              cssClass: "toast-login",
              on: {
                closed: function () {
                  self.toastLoginStatus = null;
                  self.$f7router.navigate("/home/");
                },
              },
            })
            .open();
        } else {
          self.$f7.params.dialog.closeByBackdropClick = true;
          self.$f7.$(".dialog-backdrop").css("background-color", "rgba(0, 0, 0, 0.74)");
          self.$f7.dialog.alert(data.Data, this.$t("common_0004"), function () {
            // self.$f7.$(".dialog-backdrop").css("background", "transparent");
          });
          self.updateVerify();
        }
      } catch (error) {
        self.$f7.params.dialog.closeByBackdropClick = true;
        self.$f7.$(".dialog-backdrop").css("background-color", "rgba(0, 0, 0, 0.74)");
        self.$f7.dialog.alert(this.$t("login_0018"), this.$t("common_0004"));
      } finally {
        this.closeLoginLoading();
        this.cleanupPowWorker();
        this.isSigningIn = false;
      }
    },


    updateVerify() {
      const uid = common.uuid();
      setCookie("u", uid, 7);
      this.verifyUrl = `${api.verifyimage}?u=${uid}`;
    },
    focusVerify() {
      const uid = common.uuid();
      setCookie("u", uid, 7);
      this.verifyUrl = `${api.verifyimage}?u=${uid}`;
    },
    setUserStore(u, p, d) {
      const self = this;
      if (self.toggleChecked) {
        setStore("lu", u);
        setStore("lp", p);
      }
      const user = {
        la: d.LastLoginAddress,
        li: d.LastLoginIP,
        lt: d.LastLoginTs,
      };

      // setStore('ui', JSON.stringify(user));
      // setStore('lv', d.VipLevelName);
    },
    rememberPwd(event) {
      const self = this;
      if (!event.target.checked) {
        removeStore("lu");
        removeStore("lp");
        self.username = "";
        self.password = "";
        self.toggleChecked = false;
      } else {
        self.toggleChecked = true;
      }
    },
    togglePassword(event) {
      const self = this;
      const $$ = self.$f7.$;
      if (!self.togglePwdType) {
        self.togglePwdType = true;
        $$("#login-pwd").attr("type", "text");
      } else {
        self.togglePwdType = false;
        $$("#login-pwd").attr("type", "password");
      }
    },
    checkUserLogin() {
      const self = this;
      if (self.getLoginState) {
        checkUserLogin().then((data) => {
          if (!data.Data || data.Code === "SessionNotExist") {
            clearInterval(self.checkInterval);
            self.SETLOGINSTATE(false);
            common.logoutEvent();
            self.$f7router.navigate(`/`);
          }
        });
      }
    },
    loginCheck() {
      const self = this;
      clearInterval(self.checkInterval);
      self.checkUserLogin();
      self.checkInterval = setInterval(() => {
        self.checkUserLogin();
      }, 15000);
    },
    getMerchantInfoDetail() {
      const self = this;
      getInfo().then((data) => {
        if (data.Code === "NoError" && data.Data) {
          self.baseInfo = data.Data.BaseInfo;
          setStore("ShowTW", data.Data.BaseInfo.ShowTW);
        }
      });
    },
    forgetPwd() {
      const self = this;
      const baseInfo = self.getMerchantInfo.BaseInfo;
      if (baseInfo.CSType == 2) {
        if (!this.onlineCustomLoaded) {
          let loading = self.$f7.dialog
            .create({
              title: "",
              text: "Loading...",
              cssClass: "dialog-preloadgame",
            })
            .open();
          setTimeout(() => {
            loading.close();
            this.forgetPwd();
          }, 1500);
        } else {
          window.Tawk_API.toggle();
        }
      } else {
        self.onlineCustomUrl = baseInfo.MobileService;
        //self.onlinePopupOpened = true;
        window.open(self.onlineCustomUrl, "_blank");
      }
    },
    openOnlinePopup() {
      this.showOnlinePopup = true;
    },
    closeOnlinePopup() {
      this.onlinePopupOpened = false;
      this.showOnlinePopup = false;
    },
  },
  created() {
    const self = this;
    self.toggleChecked = Boolean(getStore("lu") && getStore("lp")) || false;
    self.username = self.toggleChecked ? getStore("lu") : "";
    self.password = self.toggleChecked ? getStore("lp") : "";
    self.getMerchantInfoDetail();
    self.updateVerify();
  },
  mounted() {
    const bottoming = document.getElementById('bottoming');
    if (!bottoming) return;
    if (window.innerHeight < 600) {
      bottoming.style.position = 'relative';
    } else{
      bottoming.style.position = 'absolute';

    }
  },
};
</script>
<style lang="less" scoped>
.page-content {
  margin-top: 20px;
  .login-button {
    color: #ffffff !important;
  }
  .item-media {
    .f7-icons {
      margin-top: 9px;
      font-size: 22px;

    }
  }
}
.iframe-onlineCustom {
  width: 100%;
  height: calc(100% - 0px);
  min-height: calc(100% - 0px);
}
.span-verify {
  position: var(--f7-postion-absolute);
  right: var(--f7-px-10);
  top: var(--f7-px-6);
  z-index: 2;
  img{
    border: 1px solid #3b1111;
    width: 110px;
  }
}
::v-deep .toggle input[type="checkbox"]:checked + .toggle-icon{
  background: var(--f7-THEME-color);
}
.list .item-content {
  border: 1px solid #c5c5c5;
  border-radius: 10px;
  padding-left: 10px;
}
.list .item-media + .item-inner{
  margin-left: 10px;
}
.ios .login-screen-content .list .item-inner:after {
    width: 0;
}
::v-deep .page-content::after{
  height: 0;
}
::v-deep .page-content {
    padding-bottom: 0;
    overflow-x: hidden;
    min-height: 100vh;
    position: relative;
}
</style>
